"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.switchTransitionConfig = void 0;
/**
 * Motion specs
 * @link https://coda.io/d/Motion-Foundations_d5KlLHcBPlL/CDS-Switch_su7H7#_lu8Pe
 */
const switchTransitionConfig = {
  easing: 'global',
  duration: 'moderate1'
};
exports.switchTransitionConfig = switchTransitionConfig;